import List from "@/components/list";
import { Confirm } from "@/components/Confirm";
const Table = args => {
  const { listeners, parent } = args;

  const RCSelectionChange = listeners["selection-change"] || function () { };
  // 删除人员
  async function deletePerson(person) {
    try {
      await Confirm("确定删除选中号码吗?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      parent.persons.splice(parent.persons.indexOf(person), 1);
      parent.updatePersons();
      parent.fixPaginationAfterDelete();
    } catch (error) {
      if (error === "cancel") return;
    }
  }

  const Deal = ({ props: { vo } }) => {
    const person = vo.row;
    const dealConf = [
      [
        "icon-delete",
        "删除",
        () => {
          deletePerson(person);
        }
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip width="50%" content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
        {
          type: "selection",
          label: "main"
        },
        {
          label: "手机号",
          prop: "userMobile"
        },
        {
          label: "操作",
          width: 160,
          render: vo => <Deal vo={vo} />
          
        }
      ]
  return (
    <List
      {...args}
      empty-text={`尚未添加任何群发用户，点击右上角【导入名单】或【添加】进行维护`}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
